module.exports = __webpack_public_path__ + "img/ic_flexible.7935d216.svg";